const Acess = {
    APPLICATION_FITINSUR: '454',
    MENU_DASHBOARD: '317',
    MENU_ENQUIRES: '318',
    MENU_POLICIES: '319',
    MENU_CLAIMS: '320',
    MENU_PAYMENTS: '321',
    MENU_RENEWALS:'322',
    ROUTE_COTACOES: '390',
    ROUTE_DASHBOARD: '391',
    ROUTE_APOLICES: '392',
}

export default Acess;